import Debug from 'debug';
const debug = Debug(`knack.core.helpers.view.checkSceneHasParent`);
export const checkSceneHasParent = (application, scene, child_scene) => {
    debug(`scene.get('parent')`, scene.get(`parent`));
    debug(`child_scene.get('slug')`, child_scene.get(`slug`));
    if (scene.get(`parent`) === child_scene.get(`slug`)) {
        return true;
    }
    if (scene.get(`parent`)) {
        const parent_scene = application.getSceneBySlug(scene.get(`parent`));
        if (!parent_scene) {
            return false;
        }
        return checkSceneHasParent(application, parent_scene, child_scene);
    }
    return false;
};
